import { QueryClient } from "@tanstack/react-query";

/**
 * IR-1412 r2: Rotem — "there is no a major refresh - if you can smooth it. In
 * all tabs." Data Management tabs unmount on switch, so without a long gcTime
 * the cache was collected and every tab switch wiped to "Loading...". With
 * gcTime 30 min the cached list re-renders instantly and revalidates in the
 * background (staleTime 30s). Exported from its own module so tests can
 * assert the defaults without pulling in the whole route tree.
 */
export const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, gcTime: 30 * 60_000, retry: 1 } },
});
